import { filter } from "lodash";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import TableColumnOrder from "../TableColumnOrder";
import DeleteModal from "../DeleteModal";
import HapagLogo from "../../../assets/img/HapagLogo.png";
import MaerskLogo from "../../../assets/img/MaerskLogo.png";
import Tooltips from "../../Custom Components/tooltip";
import {
  deleteAllTransporterData,
  //   deleteTransporterDataAggregate,
  //   deleteTransporterDataFiveM,
  //   deleteTransporterDataTractor,
} from "../../../services/TransporterDataService";
import { toast } from "react-toastify";
import { getUser } from "../../../services/authService";
import FactoryOutCheckModal from "../FactoryOutCheckModal";
import { ErrorMsg } from "../../../utils/validator";

function TransporterActionCenter({
  date,
  setDate,
  setShowDailyPlanUploader,
  dataExportHandler,
  type,
  allColumns,
  getToggleHideAllColumnsProps,
  maerskTemplateFileExportHandler,
  hapagTemplateFileExportHandler,
  transporterUploadTemplateFileExportHandler,
  filteredUserAccessData,
  globalFilter,
  setGlobalFilter,
  selectedFlatRows,
  setNoDataState,
  setCarrierList
}) {
  const [modalShow, setModalShow] = useState(false);
  // const [showTransporterModal, setShowTransporterModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteIdAggregate, setDeleteIdAggregate] = useState("");
  const [deleteIdFiveM, setDeleteIdFiveM] = useState("");
  const [showFactoryOutModal, setFactoryOutModal] = useState(false);

  var allowToUpload = filter(filteredUserAccessData, { Upload: 1 }).length > 0;
  var allowToDownload =
    filter(filteredUserAccessData, { DownLoad: 1 }).length > 0;
  var allowToDelete = filter(filteredUserAccessData, { Delete: 1 }).length > 0;

  const deletePlan = async () => {
    if (selectedFlatRows) {
      let deleteList = "";
      let deleteListAggregate = "";
      let deleteListFiveM = "";
      const tractorFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "TRACTOR";
      });
      const aggregateFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "AGGREGATE";
      });
      const fiveMFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "5M";
      });
      tractorFilterData.length === 0
        ? setDeleteId("")
        : setDeleteId(deleteList);
      aggregateFilterData.length === 0
        ? setDeleteIdAggregate("")
        : setDeleteIdAggregate(deleteListAggregate);
      fiveMFilterData.length === 0
        ? setDeleteIdFiveM("")
        : setDeleteIdFiveM(deleteListFiveM);

      let err = [];
      for (let i = 0; i < tractorFilterData.length; i++) {
        if (tractorFilterData[i].original["IsContainerGetOut"] !== 0) {
          err.push(tractorFilterData[i].original["Booking_Number"]);
        } else {
          deleteList += tractorFilterData[i].original["TransporterDataId"];
          setDeleteId(deleteList);
        }
      }
      for (let i = 0; i < aggregateFilterData.length; i++) {
        if (aggregateFilterData[i].original["IsContainerGetOut"] !== 0) {
          err.push(aggregateFilterData[i].original["Booking_Number"]);
        } else {
          deleteListAggregate +=
            aggregateFilterData[i].original["TransporterDataId"];
          setDeleteIdAggregate(deleteListAggregate);
        }
      }
      for (let i = 0; i < fiveMFilterData.length; i++) {
        if (fiveMFilterData[i].original["IsContainerGetOut"] !== 0) {
          err.push(fiveMFilterData[i].original["Booking_Number"]);
        } else {
          deleteListFiveM += fiveMFilterData[i].original["TransporterDataId"];
          setDeleteIdFiveM(deleteListFiveM);
        }
      }

      if (err.length > 0) {
        setFactoryOutModal({
          status: true,
          msg: ErrorMsg(err),
        });
      } else {
        const payload = [
          {
            TractorId: deleteId,
            AggregateId: deleteIdAggregate,
            FiveMId: deleteIdFiveM,
            DataAvailable: "No",
            Deleted_By: getUser().uid,
          },
        ];

        try {
          const response = await deleteAllTransporterData(payload);
          setShowDeleteModal({ status: true, msg: response.data.Message });
        } catch (error) {
          toast.error("Unable to  delete records...please try again");
        }
      }
    }
  };
  return (
    <>
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          hide={() => setShowDeleteModal(false)}
          label="delete plan"
          dataType="Transporter"
          type={type}
          date={date}
          selectedDeleteRows={selectedFlatRows}
          setNoDataState={setNoDataState}
          setCarrierList={setCarrierList}
        />
      )}
      {modalShow && (
        <TableColumnOrder
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
      {/* <FactoryOutCheckModal
        showModal={showFactoryOutModal}
        hide={() => setFactoryOutModal(false)}
        label="change Module"
        button="ok"
        setNoDataState={setNoDataState}
      /> */}
      <div className="flex-row-align-center">
        <Form.Control
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="hiden-inp"
          placeholder="search here.."
          style={{ width: "auto" }}
        />
        {type !== "month" && (
          <>
            <div
              style={{
                display: "flex",
                width: "200px",
                alignItems: "center",
                marginLeft: "10px",
              }}
            >
              <strong>From-</strong>
              <Form.Control
                type="date"
                value={date.fromdate}
                onChange={(e) => {
                  if (e.target.value <= date.todate) {
                    setDate({ ...date, fromdate: e.target.value });
                  } else {
                    setDate({ ...date, fromdate: date.fromdate });
                    alert("From date should not greater than To date.");
                  }
                }}
                name="fromDate"
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "200px",
                alignItems: "center",
                marginLeft: "10px",
              }}
            >
              <strong>To-</strong>
              <Form.Control
                type="date"
                value={date.todate}
                onChange={(e) => {
                  if (e.target.value >= date.fromdate) {
                    setDate({ ...date, todate: e.target.value });
                  } else {
                    setDate({ ...date, todate: date.todate });
                    alert("To date should not lesser than From date.");
                  }
                }}
                name="toDate"
              />
            </div>
          </>
        )}
        {allowToUpload && (
          // <Tooltips content={"Upload Plan"} direction="down">
          //   <button
          //     className="tractorActionCenter__upload"
          //     onClick={() => setShowDailyPlanUploader(true)}
          //   >
          //     <i class="bx bx-upload" style={{ transform: "scale(1.5)" }}></i>
          //   </button>
          // </Tooltips>
          <Tooltips content={"Upload Plan"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => setShowDailyPlanUploader(true)}
            >
              <i class="bx bx-upload"></i>
            </button>
          </Tooltips>
        )}
        {allowToDownload && (
          // <Button
          // 	className="btn btn-sm btn-tbl"
          // 	onClick={() => dataExportHandler()}
          // >
          // 	Export <i className="fi fi-rr-cloud-download"></i>
          // </Button>
          <Tooltips content={"Export"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => dataExportHandler()}
            >
              <svg
                viewBox="0 0 512 512"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Combined-Shape"
                      fill="#ffffff"
                      transform="translate(64.000000, 48.915055)"
                    >
                      <path d="M170.666667,36.418278 L170.666667,79.0849447 L42.6666667,79.0849447 L42.6666667,356.418278 L341.333333,356.418278 L341.333333,228.418278 L384,228.418278 L384,399.084945 L0,399.084945 L0,36.418278 L170.666667,36.418278 Z M313.751611,0 L414.169889,100.418278 L313.751611,200.836556 L283.581722,170.666667 L332.485,121.751 L277.333333,121.751611 C243.249474,121.751611 215.388568,148.395237 213.441977,181.991125 L213.333333,185.751611 L213.333333,292.418278 L170.666667,292.418278 L170.666667,185.751611 C170.666667,128.391511 215.942543,81.6061582 272.706355,79.1834943 L277.333333,79.0849447 L332.484,79.084 L283.581722,30.1698893 L313.751611,0 Z"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </Tooltips>
        )}
        {/* </>
        )} */}
        {allowToDownload && (
          // <Button
          // 	className="btn btn-sm btn-tbl"
          // 	onClick={() => transporterUploadTemplateFileExportHandler()}
          // >
          // 	Template{" "}
          // 	<i class="bx bx-download" style={{ transform: "scale(1.3)" }}></i>
          // </Button>
          <Tooltips content={"Download Template"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => transporterUploadTemplateFileExportHandler()}
            >
              <i class="bx bx-download"></i>
            </button>
          </Tooltips>
        )}
        {allowToDownload && (
          <Tooltips content={"Download Template"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => maerskTemplateFileExportHandler()}
            >
              <img src={MaerskLogo} alt="Maersk Template" width="20px" />
            </button>
          </Tooltips>
          // <Button
          // 	className="btn btn-sm btn-tbl"
          // 	onClick={() => maerskTemplateFileExportHandler()}
          // >
          // 	<img
          // 		src={MaerskLogo}
          // 		alt="Maersk Template"
          // 		width="20px"
          // 		style={{ marginRight: "5px" }}
          // 	/>
          // 	<i class="bx bx-download"></i>
          // </Button>
        )}
        {allowToDownload && (
          <Tooltips content={"Download Template"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => hapagTemplateFileExportHandler()}
            >
              <img src={HapagLogo} alt="Hapag Template" width="20px" />
            </button>
          </Tooltips>
          // <Button
          // 	className="btn btn-sm btn-tbl"
          // 	onClick={() => hapagTemplateFileExportHandler()}
          // >
          // 	<img
          // 		src={HapagLogo}
          // 		alt="Hapag Template"
          // 		width="25px"
          // 		style={{ marginRight: "5px" }}
          // 	/>
          // 	<i class="bx bx-download" style={{ transform: "scale(1.3)" }}></i>
          // </Button>
        )}
        {allowToDelete && (
          <Tooltips content={"Delete"} direction="down">
            <button
              className="transporterActionCenter__delete"
              variant="danger"
              onClick={deletePlan}
              disabled={selectedFlatRows.length === 0}
              id="transporterBulkDelete"
              // disabled={loading}
            >
              <i class="bx bxs-trash"></i>
            </button>
          </Tooltips>
        )}
        <Tooltips content={"Column Filter"} direction="down">
          <button
            className="tableColumnFilter_btn "
            onClick={() => setModalShow(true)}
          >
            <i class="bx bx-columns tableColumnFilter"></i>
          </button>
        </Tooltips>
      </div>
    </>
  );
}

export default TransporterActionCenter;
